import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  BUYER_TYPE,
  BUYER_TYPES,
  displayUserName,
} from '../../../../services/utilityFunctions';
import TextFilter from '../../../../commonComponents/lists/filters/TextFilter';
import DateRange from '../../../../commonComponents/forms/inputs/DateRange';
import OpportunitiesListHelper from '../helpers/opportunitiesListHelper';
import translate from '../../../../commonComponents/translate';
import User from '../../../../../../../domain/models/user';
import UserProp from '../../../../commonComponents/propTypes/userProp';
import Select from '../../../../commonComponents/forms/inputs/Select';
import AsyncSelector from '../../../../commonComponents/forms/inputs/AsyncSelector';

const USER_REFERRAL_LIST = '/table/user/minified/list';

function OpportunitiesListFilters(props) {
  const { t, onFilterChange, filters, loggedUser } = props;
  const { search, startDate, endDate, buyerType } = filters || {};
  const { type } = loggedUser || {};

  const buyerTypeItems = useMemo(
    () =>
      BUYER_TYPES.map(bType => ({
        text: t(`opportunities.buyer_type.${bType}`),
        id: bType,
      })),
    [],
  );

  return (
    <div className="opportunities-filters">
      <TextFilter
        value={search}
        onChange={onFilterChange('search')}
        isSearch
        placeholder={t('search.number')}
        id="searchFilter"
        wrapperClass="searchFilter"
      />
      <DateRange
        id="filterDate"
        startDate={startDate}
        endDate={endDate}
        placeholder={t('trainers.edit.selectData')}
        onChange={({ startDate: sDate, endDate: eDate }) => {
          onFilterChange('date')(sDate, eDate);
        }}
        onClear={() => {
          onFilterChange('date')(null, null);
        }}
      />
      {type === User.TYPE.COLLABORATOR ? (
        <div className="buyerTypeFilter">
          <Select
            id="buyerTypeFilter"
            items={buyerTypeItems}
            value={buyerType}
            onChange={onFilterChange('buyerType')}
            placeholder={t('shop.buyer_type')}
            searchable={false}
          />
        </div>
      ) : null}
      {filters?.buyerType !== BUYER_TYPE.OWNER &&
      type === User.TYPE.COLLABORATOR ? (
        <div className="userReferral">
          <AsyncSelector
            url={USER_REFERRAL_LIST}
            params={{
              ids: filters?.owner || [],
            }}
            query={{
              sponsoredBy: loggedUser?._id,
            }}
            onDetailEndpoint={() => USER_REFERRAL_LIST}
            displayNameInSelector={displayUserName}
            id="userReferral"
            headers={{
              'Accept-Version': '1.0.0',
              'X-Gamification-API': 'Organization',
            }}
            onChange={onFilterChange('owner')}
            placeholder={t('order_customer')}
            groupProps={{
              ignoreWrapper: true,
            }}
            value={filters.owner}
            allowClear
            ignoreWrapper
            pageSize={10}
          />
        </div>
      ) : null}
    </div>
  );
}

OpportunitiesListFilters.propTypes = {
  t: PropTypes.func.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  filters: PropTypes.shape(OpportunitiesListHelper.propType),
  loggedUser: PropTypes.shape(UserProp.propType).isRequired,
};

OpportunitiesListFilters.defaultProps = {
  filters: OpportunitiesListHelper.defaultProp,
};

export default translate(OpportunitiesListFilters);
